const labels = ['cz', 'czdirect', 'just', 'pzp' , 'zorgkantoor'];

export function findLabel() {
	return labels.find((label) => document && document.documentElement && document.documentElement.classList && document.documentElement.classList.contains(label)) || 'cz';
}

export function filterInt(value) {
	if (/^[-+]?(\d+|Infinity)$/.test(value)) {
		return Number(value);
	} else {
		return 0; // return 0 instead of NaN so it can be used as falsy
	}
}

export function isUrlExternal(url) {
	const host = window?.location?.hostname;

	if (!host) return false;

	let linkHost = window?.location?.hostname;

	if (/^https?:\/\//.test(url)) { // Absolute URL.
		// The easy way to parse an URL, is to create <a> element.
		let parser = document.createElement('a');
		parser.href = url;

		linkHost = parser.hostname;
	}

	return host !== linkHost;
}
